export default __webpack_public_path__ + "static/montserrat-v26-latin-ext-regular-9bddd99255e79f29192221ad24f9d631.woff2";